import React from 'react';
import { getCurrencyByDomain } from '@/utils/domain';
import { useCurrencyStore } from '@/store/currency';
import Link from '../../Link';
import '../index.css';

export function FamilyBundlePricing() {
  const currencyStore = useCurrencyStore();
  function formatPrice(price: number, currency: string): string {
    let formattedPrice: string;

    if (currency === `CAD`) {
      formattedPrice = `${Math.round(price * 1.429)} CAD`; // Convert to CAD and Round to the nearest whole number
    } else {
      formattedPrice = `${Math.round(price)} `; // Default to USD Nd Round to the nearest whole number
    }
    return formattedPrice;
  }

  const domain = typeof window !== `undefined` ? window.location.hostname : ``;
  const selectedCurrency = getCurrencyByDomain(domain);

  const stripeLink = process.env.GATSBY_FAMILY_BUNDLE_STRIPE_URL;

  return (
    <div className="w-full md:p-[24px] p-8 h-full md:mt[40px] slg:mt-0 md:pt-[48px]">
      <div className="flex flex-col gap-y-[23px]">
        <div>
          <img src="/images/gut-scan-test.svg" alt="" className="w-full" />
        </div>
        <div>
          <div className="flex flex-col">
            <h3 className="text-xl font-medium text-navy-blue">
              GutScan Family Bundle (3 tests)
            </h3>
            <span className="italic text-[#A3A1A8] font-medium mt-3">
              Practitioners & non-practitioners
            </span>
          </div>
          <div className="flex flex-col gap-y-5">
            <p className="text-base font-medium text-navy-blue mt-5">
              This is ideal for a family, or for time-lapse testing.
            </p>
            <div>
              {currencyStore.currency === `US$` ? (
                <div className="flex justify-between gap-x-4">
                  <span className="text-2xl font-bold text-primary">
                    US${formatPrice(540, selectedCurrency)}
                  </span>
                  <span className="p-[10px] border border-dashed border-[#386EFF] rounded-lg bg-[#E5ECFF] text-sm font-medium">
                    Buy 3 tests and save $60
                  </span>
                </div>
              ) : (
                <div className="flex justify-between gap-x-4">
                  <span className="text-2xl font-bold text-primary">
                    CA${formatPrice(735, selectedCurrency)}
                  </span>
                </div>
              )}
              {/* <p className="text-base text-[#A3A1A8] font-medium mt-2">
                Save <strong>$30</strong> with July 4th Sale! Use discount code
                <span className="font-bold text-primary"> INDEPENDENCE30 </span>
                at checkout.
              </p> */}
            </div>
          </div>
        </div>
        {domain.includes(`.ca`) ||
        domain.includes(`vitract-ca.netlify.app/pricing/`) ? (
          <Link href={stripeLink}>
            <button
              type="button"
              className="mt-auto w-full border border-navy-blue border-solid rounded text-navy-blue hover:bg-navy-blue hover:text-white py-3 text-base font-medium"
            >
              Order Now
            </button>
          </Link>
        ) : (
          <Link href={stripeLink}>
            <button
              type="button"
              className="mt-auto w-full border border-navy-blue border-solid rounded text-navy-blue hover:bg-navy-blue hover:text-white py-3 text-base font-medium"
            >
              Order Now
            </button>
          </Link>
        )}
      </div>
    </div>
  );
}
